import React, {PureComponent} from 'react';
import {Field, getFormValues, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {get, put} from '../../redux/modules/text';
import Image from '../../components/image/Image';
import Editor from '../../components/editor/Editor';

const FORM_NAME = 'PartnerForm';

const Home = () => {
  return (
    <div className="row home">
      <div className="row">
        <div className="col-xs-4">
          <label>Image</label>
          <Field
            name="photo1"
            component={Image}/>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12">
          <label>Text</label>
          <Field
            name="body"
            component={Editor}/>
        </div>
      </div>
    </div>
  );
};


class PartnerForm extends PureComponent {

  handlerSubmit(values) {
    const {getAction, putAction, close} = this.props;
    const newData = {...values};

    delete newData.next_news;
    delete newData.last_news;
    delete newData.articles;

    return putAction('home', newData)
      .then(() => {
        getAction('home');
        close();
      });
  }

  render() {
    const {handleSubmit, pristine, reset, submitting} = this.props;
    return (
      <form
        className="planet-form"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>

        <Home/>

        <div className="clearfix"></div>
        <div className="row text-right form-buttons">
          <button disabled={pristine || submitting} loading={submitting} type="submit"
                  className="btn btn-primary btn-xl">Save
          </button>
          <button disabled={pristine || submitting} loading={submitting} type="button"
                  className="btn btn-primary btn-xl"
                  onClick={reset}>Clear
          </button>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      myValues: getFormValues(FORM_NAME)(state) || {},
      enableReinitialize: true,
      initialValues: props.defaultValues
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/home/HomeForm.js